import { ICoreContext } from '@msdyn365-commerce/core-internal';
import axios from 'axios';
import { useState } from 'react';
import { ICancellationFormData, ICancellationRequestBody } from '../cus-cancellation-form.data';
import { ICusCancellationFormResources } from '../cus-cancellation-form.props.autogenerated';

export default function useCancellationFormRequests(
    formData: ICancellationFormData,
    context: ICoreContext,
    resources: ICusCancellationFormResources,
    clearFormData: () => void,
    supportEmail: string
) {
    const [isToasterOpen, setIsToasterOpen] = useState(false);
    const [isFormLoading, setIsFormLoading] = useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const submitCancellationForm = async () => {
        if (!formData.email || !formData.orderNumber) {
            return;
        }

        setIsFormLoading(true);
        setErrorMessage(null);

        const apiData: { url: string; payload: ICancellationRequestBody; headers: { oun: string } } = {
            url: `${context.request.apiSettings.baseUrl}Commerce/SubmitSupportForm`,
            payload: {
                formData: {
                    SupportEmail: supportEmail,
                    Email: formData.email,
                    OrderNumber: formData.orderNumber,
                    Subject: `Cancellation request - ${formData.orderNumber}`,
                    Items: []
                }
            },
            headers: { oun: context.request.apiSettings.oun }
        };

        try {
            context.telemetry.error('SubmitCancellationForm request', {
                url: apiData.url,
                payload: apiData.payload,
                headers: apiData.headers
            });

            const response = await axios.post(apiData.url, apiData.payload, {
                headers: apiData.headers
            });

            if (response.data?.SuccessStatusCode === false) {
                context.telemetry.error('SubmitCancellationForm failed', {
                    message: response.data?.Message || 'Unknown error'
                });

                setErrorMessage(resources.cancellationFormGenericErrorMessage);
                setIsFormLoading(false);
                return;
            }

            clearFormData();
            setIsToasterOpen(true);
            setIsFormSubmitted(true);
        } catch (error) {
            context.telemetry.error('SubmitCancellationForm failed', {
                message: error instanceof Error ? error.message : 'Unknown error',
                error
            });

            setErrorMessage(resources.cancellationFormGenericErrorMessage);
        } finally {
            setIsFormLoading(false);
        }
    };

    return {
        submitCancellationForm,
        isToasterOpen,
        setIsToasterOpen,
        isFormLoading,
        isFormSubmitted,
        errorMessage
    };
}
